import { AddResortForm } from '@/components/dashboard/AddResortForm';

export default function HostAddResort() {
  return <AddResortForm />;
}
